import { render } from "./StepYourCircumstances.vue?vue&type=template&id=30ac0e39"
import script from "./StepYourCircumstances.vue?vue&type=script&lang=js"
export * from "./StepYourCircumstances.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__